// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ysdt","colMin":"styles_colMin__34oKq"};